import { Avatar } from 'src/components/Avatar';
import { Icon } from 'src/components/Icon';
import { theme } from 'src/styles/theme';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { GoBookmark, GoPencil } from "react-icons/go";
import { MdOutlinePlaylistAdd } from "react-icons/md";
import { ResponsesPanel } from './ResponsesPanel';
import RIghtArrow from "src/assets/icons/double-arrow-right.svg";
import { BsUnindent } from 'react-icons/bs';
import { useBoundStore } from 'src/store';
import { useMediaQuery } from 'react-responsive';
import Verizon from "src/assets/brands/verizon.png";

interface QcastHeaderProps {
  qcasterName: string;
  qseriesName: string;
  avatarSrc?: string;
  showBackBtn?: boolean;
  mediaType: string;
  onShare?: (status: boolean) => void;
}

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  // margin-bottom: 32px;
  // margin-top: 6px;
  padding: 16px 16px;

  z-index: 999999999999;
`;

const QcasterInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`;

const InfoText = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Name = styled.span`
  font-family: ${theme.fonts.primary};
  font-size: ${theme.fontSizes.xl};
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.transparentBlack};
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;

  @media (max-width: ${theme.breakpoints.desktop}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.desktop} / 1920));
  }

  @media (max-width: ${theme.breakpoints.mobile}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.mobile} / 1920));
  }

  @media (max-width: ${theme.breakpoints.tablet}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.tablet} / 1920));
  }

  @media (max-width: ${theme.breakpoints.maxTablet}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.maxTablet} / 1920));
  }

  @media (max-width: ${theme.breakpoints.maxDesktop}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.maxDesktop} / 1920));
  }
`;

const Separator = styled.div`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: ${theme.colors.transparentBlack};
`;

const SeriesName = styled.span`
  font-family: ${theme.fonts.primary};
  font-size: ${theme.fontSizes.xl};
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.black};
  opacity: 0.7;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;

  @media (max-width: ${theme.breakpoints.desktop}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.desktop} / 1920));
  }

  @media (max-width: ${theme.breakpoints.mobile}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.mobile} / 1920));
  }

  @media (max-width: ${theme.breakpoints.tablet}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.tablet} / 1920));
  }

  @media (max-width: ${theme.breakpoints.maxTablet}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.maxTablet} / 1920));
  }

  @media (max-width: ${theme.breakpoints.maxDesktop}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.maxDesktop} / 1920));
  }
`;

const SubscribeButton = styled.button`
  font-family: ${theme.fonts.primary};
  font-size: ${theme.fontSizes.xl};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.primary};
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 4px;
  
  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${theme.breakpoints.desktop}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.desktop} / 1920));
  }

  @media (max-width: ${theme.breakpoints.mobile}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.mobile} / 1920));
  }

  @media (max-width: ${theme.breakpoints.tablet}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.tablet} / 1920));
  }

  @media (max-width: ${theme.breakpoints.maxTablet}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.maxTablet} / 1920));
  }

  @media (max-width: ${theme.breakpoints.maxDesktop}px) {
    font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.maxDesktop} / 1920));
  }
`;

const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${theme.borderRadius.circle};
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  box-shadow: ${theme.shadows.small};
  transition: all 0.2s ease;

  svg{
    cursor: pointer;
  }
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    transform: scale(1.05);
  }
`;

const PreviewButton = styled.button`
    width: 152px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border-radius: 40px;
    padding-top: 8px 16px;
    background: #FFFFFF66;


    &>span{
        font-family: ${theme.fonts.primary};
        font-weight: ${theme.fontWeights.semiBold};
        font-size: ${theme.fontSizes.md};
        line-height: 135%;
        letter-spacing: 0%;
    }
`

export const QcastHeader: React.FC<QcastHeaderProps> = ({
  qcasterName,
  qseriesName,
  avatarSrc,
  showBackBtn,
  mediaType,
  onShare
}) => {

  const [showResponses, setShowResponses] = useState(false);
  const {setExpandSidebar, expandSidebar} = useBoundStore();
  const isNotPC = useMediaQuery({ maxWidth: 1023 });

  const [copied, setCopied] = useState(false);
  
  const handleShare = async () => {
    const title: string= document.title;
    const text: string = 'Qcast';
    const url: string = window.location.href;
    if (navigator.share) {
      
      try {
        await navigator.share({
          title: title || document.title,
          text: text || '',
          url: url || window.location.href,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      
    }
  };

  const handleShareOnSocialMedia=(media: string)=>{
    const url: string = window.location.href;
    const title: string= document.title;
    const socialUrls = {
      twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    };
    
    // You could open a modal with these links instead
    window.open(socialUrls[media], '_blank');
  }
  const handleEmail = () => {
    const mailtoLink = `mailto:?subject=${encodeURIComponent(document.title)}&body=${encodeURIComponent('Qcast' + '\n' + window.location.href)}`;
    window.location.href = mailtoLink;
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Error copying to clipboard:', error);
    }
  };

  useEffect(()=>{
    if(mediaType !== ''){
      handleShareOnSocialMedia(mediaType);
    }
    
  }, [mediaType])

  return (
    <HeaderContainer>
      <QcasterInfo>
        <Avatar src={avatarSrc} alt={"Verizon"} size={32} />
        <InfoText>
          <Name>{qcasterName}</Name>
          {/* {!showBackBtn &&
            <>
              <Separator />
              <SeriesName>{qseriesName}</SeriesName>
              <Separator />
              <SubscribeButton>Subscribe</SubscribeButton>
            </>
          } */}
        </InfoText>
      </QcasterInfo>
      {showBackBtn && (
        <PreviewButton>
          <span>Back to Review</span>
          <GoPencil size={13.22} />
        </PreviewButton>
      )}
      <ActionButtons>
        {/* <IconButton>
          <GoBookmark color={theme.colors.black} size={20} />
        </IconButton>
        
        <IconButton>
          <MdOutlinePlaylistAdd color={theme.colors.black} size={20} />
        </IconButton> */}
        {/* <IconButton onClick={()=>{onShare(true)}}>
          <Icon name="share" color={theme.colors.black} size={20} />
        </IconButton> */}
        {/* <IconButton onClick={()=>{setShowResponses(!showResponses)}}>
          <Icon name="more" color={theme.colors.black} size={20} />
        </IconButton> */}
        {expandSidebar && (
          <IconButton onClick={()=>{setExpandSidebar(!expandSidebar)}}>
            <BsUnindent color={theme.colors.black} size={20} />
          </IconButton>  
        )}
        
      </ActionButtons>
      <ResponsesPanel setShowResponses={setShowResponses} responseCount={2} showComponent={showResponses} />
    </HeaderContainer>
  );
};
